export const RISK_PROFILE_FLUCTUATIONS = [
    {
        id: '8',
        pessimistic: -6,
        median: 1.7,
        optimistic: 10,
    },
    {
        id: '9',
        pessimistic: -7,
        median: 25,
        optimistic: 13,
    },
    {
        id: '10',
        pessimistic: -10,
        median: 3.2,
        optimistic: 19,
    },
    {
        id: '11',
        pessimistic: -14,
        median: 3.9,
        optimistic: 25,
    },
    {
        id: '12',
        pessimistic: -20,
        median: 4.7,
        optimistic: 35,
    },
];
